import { createConsts, createActions } from '../../utils/redux';

const supportedActions = ['OPEN_VIEWER', 'CLOSE'];

export const consts = createConsts('ui', 'pdfViewer', ...supportedActions);
export const actions = createActions(consts);

const initialState = {
  opened: false,
  pdf: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case consts.OPEN_VIEWER:
      return { opened: true, pdf: action.payload.binary };
    case consts.CLOSE:
      return initialState;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/ui/pdfViewer.js